/**
 * @namespace Requester.v2.perception
 * @intdocs
 */

export * from './SetPresentPerson';